export const INFO_NOTIFICATION = 'info'
export const WARNING_NOTIFICATION = 'warning'
export const ERROR_NOTIFICATION = 'error'
export const SUCCESS_NOTIFICATION = 'success'

export const notificationTypes = {
  COMPLAINT_APPROVAL_REQUEST: WARNING_NOTIFICATION,
  INVENTORY_REQUEST: SUCCESS_NOTIFICATION
}

export const NOTIFICATION_CHANNEL = 'notification'
export const USER_GUIDE_LINK =
  'https://drive.google.com/file/d/1SYc9FRRiI2OhhnYUAaZEgEYINrv1Hzj_/view?usp=drive_link'
export const PUSHER_CLIENT_LIB = 'https://js.pusher.com/8.2.0/pusher.min.js'

export const SelectionTypes = {
  EMPLOYEES: 'EMPLOYEES',
  TEAMS: 'TEAMS',
  CUSTOMERS: 'CUSTOMERS',
  PARTNERS: 'LENDERS',
  WORKFLOW_TEMPLATES: 'WORKFLOW_TEMPLATES'
}

export const TAB_ITEMS = {
  COLLECTION: [
    {
      key: 'Cases',
      nameKey: 'caseTable',
      name: 'Cases',
      component: 'Cases',
      icon: 'mdi-briefcase'
    },
    {
      key: 'Visits',
      nameKey: 'visitTable',
      name: 'Visits',
      component: 'Visits',
      icon: 'mdi-map-marker'
    },
    {
      key: 'CaseAnalytics',
      nameKey: 'caseAnalyticsTable',
      name: 'Case Analytics',
      component: 'CaseAnalytics',
      icon: 'mdi-chart-line'
    },
    {
      key: 'CallHistory',
      nameKey: 'callHistoryTable',
      name: 'Call History',
      component: 'CallHistory',
      icon: 'mdi-phone-clock'
    },
    {
      key: 'CaseCustomer',
      nameKey: 'customerTable',
      name: 'Customers',
      component: 'Customer',
      icon: 'mdi-account-group'
    },
    {
      key: 'Audit',
      nameKey: 'auditTable',
      name: 'Audit',
      component: 'AuditTable',
      icon: 'mdi-history'
    }
  ],
  TEAM_REVIEW: [
    {
      key: 'attendance',
      name: 'Attendance Muster',
      component: 'AttendanceTable',
      visibility: true,
      icon: 'mdi-clock-time-four'
    },
    // {
    //   key: 'roaster',
    //   name: 'Roaster',
    //   component: 'RoasterTable',
    //   visibility: true,
    //   icon: 'mdi-calendar-month'
    // },
    {
      key: 'calendar',
      name: 'Calendar View',
      component: 'TeamReviewCalendar',
      visibility: true,
      icon: 'mdi-calendar'
    },
    {
      key: 'map',
      name: 'Timeline',
      component: 'MapView',
      visibility: true,
      icon: 'mdi-timeline-clock'
    }
  ],
  NOTIFICATION: [
    {
      key: 'notifications',
      name: 'Notifications',
      component: 'Notifications',
      visibility: true,
      icon: 'mdi-bell'
    },
    // {
    //   key: 'templates',
    //   name: 'Templates',
    //   component: 'NotificationCard',
    //   visibility: true,
    //   icon: 'mdi-file-document-outline'
    // },
    {
      key: 'letters',
      name: 'Templates',
      component: 'LetterTemplates',
      visibility: true,
      icon: 'mdi-email-edit-outline'
    },
    {
      key: 'triggers',
      name: 'Template Triggers',
      component: 'TemplateTriggers',
      visibility: true,
      icon: 'mdi-lightning-bolt-outline'
    }
  ],
  ORGANIZATION: [
    {
      key: 'employees',
      name: 'Peoples',
      component: 'EmployeesPage',
      visibility: true,
      icon: 'mdi-account-tie'
    },
    {
      key: 'role',
      name: 'Roles',
      component: 'Roles',
      visibility: true,
      icon: 'mdi-shield-account'
    },
    {
      key: 'branches',
      name: 'Office Locations',
      component: 'BranchTeam',
      visibility: true,
      icon: 'mdi-office-building'
    },
    {
      key: 'departmentdesignation',
      name: 'Departments',
      component: 'DepartmentDesignation',
      visibility: true,
      icon: 'mdi-office-building'
    },
    {
      key: 'Salarytemplate',
      name: 'Payroll',
      component: 'SalaryTemplate',
      visibility: true,
      icon: 'mdi-currency-usd'
    },
    {
      key: 'leave',
      name: 'Leaves',
      component: 'LeaveManagement',
      visibility: true,
      icon: 'mdi-calendar-month'
    },
    {
      key: 'holiday',
      name: 'Holidays',
      component: 'HolidayManagement',
      visibility: true,
      icon: 'mdi-beach'
    }
  ]
}

export const routeConfig = {
  employees: {
    path: '/workforce/organization',
    selectValues: [SelectionTypes.EMPLOYEES],
    queryKeys: {
      [SelectionTypes.EMPLOYEES]: { default: 'search' }
    },
    visibility: true,
    activeTabFilter: {
      employees: [SelectionTypes.EMPLOYEES],
      role: [],
      branches: [],
      departmentdesignation: [],
      Salarytemplate: [],
      leave: [],
      holiday: [],
      Default: [SelectionTypes.EMPLOYEES]
    }
  },
  'team-review': {
    path: '/workforce/team-review',
    selectValues: [SelectionTypes.EMPLOYEES],
    queryKeys: {
      [SelectionTypes.EMPLOYEES]: { default: 'search' }
    },
    visibility: true,
    activeTabFilter: {
      calendar: [],
      Default: [SelectionTypes.EMPLOYEES]
    }
  },
  collection_management: {
    path: '/workforce/collection_management',
    selectValues: [SelectionTypes.EMPLOYEES, SelectionTypes.CUSTOMERS],
    queryKeys: {
      [SelectionTypes.EMPLOYEES]: { default: 'empId', CallHistory: 'empNo' },
      [SelectionTypes.TEAMS]: { default: 'search' },
      [SelectionTypes.CUSTOMERS]: { default: 'search' }
    },
    visibility: true,
    activeTabFilter: {
      CaseCustomer: [SelectionTypes.CUSTOMERS],
      CaseAnalytics: [SelectionTypes.EMPLOYEES],
      EMI: [SelectionTypes.CUSTOMERS],
      Default: [SelectionTypes.EMPLOYEES, SelectionTypes.CUSTOMERS]
    }
  },
  loan_management: {
    path: '/workforce/loan_management',
    selectValues: [SelectionTypes.EMPLOYEES, SelectionTypes.CUSTOMERS, SelectionTypes.PARTNERS],
    queryKeys: {
      [SelectionTypes.EMPLOYEES]: { default: 'empId', CallHistory: 'empNo' },
      [SelectionTypes.TEAMS]: { default: 'search' },
      [SelectionTypes.CUSTOMERS]: { default: 'customer' },
      [SelectionTypes.PARTNERS]: { default: 'partnerId' }
    },
    visibility: true,
    activeTabFilter: {
      CaseCustomer: [SelectionTypes.CUSTOMERS],
      CaseAnalytics: [SelectionTypes.EMPLOYEES],
      EMI: [SelectionTypes.CUSTOMERS],
      Default: [SelectionTypes.EMPLOYEES, SelectionTypes.CUSTOMERS, SelectionTypes.PARTNERS]
    }
  },
  customers: {
    path: '/workforce/customers',
    selectValues: [SelectionTypes.CUSTOMERS],
    queryKeys: {
      [SelectionTypes.CUSTOMERS]: { default: 'customer' }
    },
    visibility: true
  },
  partners: {
    path: '/workforce/partners',
    selectValues: [SelectionTypes.PARTNERS],
    queryKeys: {
      [SelectionTypes.PARTNERS]: { default: 'partner' }
    },
    visibility: true
  },
  'workflow-steps': {
    path: '/workforce/workflow-steps',
    selectValues: [SelectionTypes.WORKFLOW_TEMPLATES],
    queryKeys: {
      [SelectionTypes.WORKFLOW_TEMPLATES]: { default: 'search' }
    },
    visibility: true
  },
  base: {
    path: '/workforce/base',
    selectValues: [SelectionTypes.EMPLOYEES, SelectionTypes.CUSTOMERS],
    queryKeys: {
      [SelectionTypes.EMPLOYEES]: { default: 'empId', CallHistory: 'empNo' },
      [SelectionTypes.TEAMS]: { default: 'search' },
      [SelectionTypes.CUSTOMERS]: { default: 'search' }
    },
    visibility: true,
    activeTabFilter: {
      Cases: [SelectionTypes.EMPLOYEES, SelectionTypes.CUSTOMERS],
      Default: [SelectionTypes.EMPLOYEES, SelectionTypes.CUSTOMERS]
    }
  }
}

export const workFlowStepsOptions = {
  loan: {
    'Lead Generation Steps': {
      'Lead Generation': ['Initial customer inquiry'],
      'Eligibility Check': ['Basic qualification screening'],
      'Product Selection': ['Loan type', 'Amount type']
    },
    'Application & Documentation': {
      'Application Submission': ['Complete loan application form'],
      'Document Collection': ['Gather required documents'],
      'Document Verification': ['Validate submitted documents'],
      'KYC Verification': ['Identity verification', 'Address verification'],
      'Income Verification': ['Salary slips', 'ITR', 'Bank statements']
    },
    'Credit Assessment': {
      'CIBIL/Credit Score Check': ['Credit bureau report'],
      'Credit Analysis': ['Evaluate creditworthiness'],
      'Bank Statement Analysis': ['Cash flow assessment'],
      'Employment Verification': ['Job confirmation'],
      'Reference Check': ['Personal references', 'Professional references']
    },
    'Property/Collateral (for secured loans)': {
      'Property Valuation': ['Asset appraisal'],
      'Legal Verification': ['Title clearance', 'Legal clearance'],
      'Technical Evaluation': ['Property inspection'],
      'Insurance Verification': ['Asset insurance check']
    },
    'Approval Process': {
      'Credit Committee Review': ['Internal approval process'],
      'Risk Assessment': ['Final risk evaluation'],
      'Loan Approval': ['Management approval'],
      'Terms Finalization': ['Interest rate', 'Tenure confirmation'],
      'Sanction Letter': ['Formal approval document']
    },
    'Documentation & Legal': {
      'Loan Agreement Preparation': ['Legal documentation'],
      'Stamp Duty & Registration': ['Legal formalities'],
      'Insurance Processing': ['Loan protection insurance'],
      'Guarantor Documentation': ['Co-signer formalities']
    },
    Disbursement: {
      'Pre-Disbursement Check': ['Final verification'],
      'Account Opening': ['Loan account creation'],
      'Disbursement Authorization': ['Final approval for release'],
      'Fund Transfer': ['Money disbursement'],
      'Disbursement Confirmation': ['Payment confirmation']
    },
    'Post-Disbursement': {
      'Welcome Kit': ['Loan documents and guidelines'],
      'EMI Setup': ['Auto-debit instructions'],
      'Account Activation': ['Loan account goes live']
    }
  },
  disbursement: {
    'Pre-Disbursement Steps': {
      'Disbursement Request': ['Customer request', 'System initiated request'],
      'Eligibility Verification': ['Check disbursement conditions'],
      'Document Compliance Check': ['Verify required documents'],
      'Outstanding Verification': ['Check pending dues', 'Check pending charges'],
      'Limit Availability Check': ['Confirm available disbursement amount'],
      'Beneficiary Verification': ['Validate recipient details'],
      'Purpose Verification': ['Confirm fund usage for specific loans']
    },
    'Disbursement Authorization': {
      'Disbursement Approval': ['Internal authorization'],
      'Signatory Verification': ['Authorized person confirmation'],
      'Compliance Check': ['Regulatory compliance verification'],
      'Risk Assessment': ['Final disbursement risk check'],
      'Manager Approval': ['Senior management sign-off']
    },
    'Fund Transfer Process': {
      'Payment Instruction Creation': ['Generate payment order'],
      'Bank Account Verification': ['Validate recipient account'],
      'Fund Reservation': ['Block amount for transfer'],
      'Payment Processing': ['Execute fund transfer'],
      'Transaction Confirmation': ['Payment success verification'],
      'Receipt Generation': ['Create disbursement receipt']
    },
    'Multiple Disbursement Specific Steps': {
      'Tranche Planning': ['Define disbursement schedule'],
      'Milestone Verification': ['Check completion criteria'],
      'Progress Assessment': ['Evaluate project/construction progress'],
      'Utilization Certificate': ['Previous disbursement usage proof'],
      'Inspection Report': ['Physical verification (for construction)'],
      'Vendor Invoice Verification': ['Direct payment validation'],
      'Retention Amount Calculation': ['Hold-back amount determination']
    },
    'Post-Disbursement Activities': {
      'Disbursement Confirmation': ['Send confirmation to customer'],
      'Account Update': ['Update loan account balance'],
      'Interest Calculation Start': ['Begin interest accrual'],
      'EMI Schedule Generation': ['Create repayment schedule'],
      'Welcome Communication': ['Send loan kit/guidelines'],
      'Insurance Activation': ['Activate loan protection insurance']
    },
    'Documentation & Compliance': {
      'Disbursement Certificate': ['Issue formal certificate'],
      'Regulatory Reporting': ['Submit required reports'],
      'Audit Trail Creation': ['Document transaction history'],
      'File Closure': ['Complete disbursement documentation'],
      'Digital Archive': ['Store electronic records']
    },
    'Account Management Setup': {
      'EMI Auto-Debit Setup': ['Configure automatic payments'],
      'Statement Generation': ['First loan statement'],
      'Online Access Activation': ['Enable digital banking'],
      'Customer Onboarding': ['Portal/app access setup'],
      'Communication Preferences': ['Set notification preferences']
    },
    'Monitoring & Tracking': {
      'Utilization Monitoring': ['Track fund usage (business loans)'],
      'Repayment Tracking Setup': ['Monitor payment behavior'],
      'Account Health Check': ['Initial account assessment'],
      'Cross-sell Opportunity': ['Identify additional products'],
      'Relationship Manager Assignment': ['Assign account manager']
    }
  },
  emi: {
    'Pre-EMI Steps': {
      'EMI Due Notification': ['Send payment reminder (7/3/1 days before)'],
      'Outstanding Balance Check': ['Verify current dues'],
      'Account Status Verification': ['Check account standing'],
      'Payment Method Validation': ['Confirm payment mode availability'],
      'Penalty Calculation': ['Calculate late fees if applicable']
    },
    'EMI Payment Process - Auto-Debit Workflow': {
      'Auto-Debit Instruction': ['System initiated payment'],
      'Bank Balance Verification': ['Check sufficient funds'],
      'Debit Authorization': ['Bank processes payment'],
      'Payment Confirmation': ['Receive payment status'],
      'Bounce Handling': ['Process failed payments']
    },
    'EMI Payment Process - Manual Payment Workflow': {
      'Payment Initiation': ['Customer initiated payment'],
      'Payment Mode Selection': ['Choose payment method'],
      'Amount Verification': ['Confirm payment amount'],
      'Payment Processing': ['Execute transaction'],
      'Receipt Generation': ['Create payment receipt']
    },
    'Document Requirements (Conditional)': {
      'Regular EMI (No Documents)': ['Standard Payment - No additional documents required']
    },
    'Document Requirements (Conditional) - Special Circumstances': {
      'Moratorium Request': ['Income loss certificate', 'Medical bills'],
      'EMI Restructuring': ['Financial hardship documents'],
      'Prepayment Request': ['NOC request form', 'ID proof'],
      'Part Payment': ['Payment instruction letter'],
      'EMI Holiday Request': ['Salary certificate', 'Company letter']
    },
    'Document Requirements (Conditional) - Business Loan EMI': {
      'Quarterly Financials': ['P&L', 'Balance Sheet (quarterly EMIs)'],
      'GST Returns': ['Tax compliance proof'],
      'Bank Statements': ['Cash flow verification'],
      'Stock Statements': ['Inventory reports (for inventory funding)'],
      'Utilization Certificate': ['Fund usage proof']
    },
    'Document Requirements (Conditional) - Construction/Home Loan EMI': {
      'Construction Progress Report': ['Work completion certificate'],
      'Contractor Bills': ['Expense verification'],
      'Insurance Renewal': ['Property insurance documents'],
      'Property Tax Receipt': ['Tax payment proof']
    },
    'Post-EMI Activities - Successful Payment': {
      'Payment Acknowledgment': ['Send receipt/confirmation'],
      'Account Statement Update': ['Reflect new balance'],
      'Credit Score Update': ['Report to credit bureaus'],
      'Next EMI Reminder Setup': ['Schedule next notification'],
      'Loyalty Points Credit': ['Award customer benefits']
    },
    'Post-EMI Activities - Failed/Missed Payment': {
      'Bounce Charges': ['Apply penalty fees'],
      'Overdue Notice': ['Send payment demand'],
      'Collection Workflow': ['Initiate recovery process'],
      'Credit Score Impact': ['Report delinquency'],
      'Account Status Update': ['Mark as overdue']
    }
  },
  loanClosure: {
    'Pre-Closure Steps': {
      'Closure Request Initiation': ['Customer closure request', 'Foreclosure application form'],
      'Outstanding Balance Calculation': [
        'Principal outstanding',
        'Accrued interest',
        'Penalty charges',
        'Pre-closure charges'
      ],
      'Pre-Closure Statement Generation': ['Forecast statement', 'Payoff amount confirmation'],
      'Pre-Closure Fee Assessment': ['Foreclosure penalty calculation', 'Processing fee check'],
      'Regulatory Compliance Check': ['RBI guidelines verification', 'Legal closure conditions']
    },
    'Settlement & Payment': {
      'Settlement Amount Confirmation': ['Total payoff amount', 'Valid up-to date'],
      'Payment Receipt': ['Full settlement payment', 'Payment mode verification'],
      'Payment Verification': ['Amount reconciliation', 'Bank confirmation'],
      'Excess Amount Refund': ['Excess payment calculation', 'Refund initiation'],
      'Cheque/Draft Verification': ['Instrument clearance check']
    },
    'Document Collection & Verification': {
      'Closure Request Form': ['Signed closure application'],
      'Identity Verification': ['Customer KYC re-check'],
      'NOC Request Processing': ['No Objection Certificate request'],
      'Original Document Return': ['Property documents', 'Original agreements'],
      'Insurance Cancellation': ['Loan protection insurance closure']
    },
    'Account Deactivation': {
      'Loan Account Closure': ['Mark account as closed in system'],
      'Auto-Debit Cancellation': ['Stop ECS/NACH mandate'],
      'Lien Release': ['Release property lien', 'Asset unencumbrance'],
      'Guarantor Release': ['Remove guarantor obligations'],
      'Credit Bureau Update': ['Report loan closure to bureaus']
    },
    'NOC & Certificate Issuance': {
      'NOC Generation': ['No Objection Certificate creation'],
      'NOC Dispatch': ['Physical/digital delivery to customer'],
      'Closure Certificate': ['Loan closure acknowledgement letter'],
      'Interest Certificate': ['Final interest certificate for tax'],
      'Foreclosure Letter': ['Official foreclosure confirmation']
    },
    'Post-Closure Activities': {
      'Customer Confirmation': ['Closure acknowledgment from customer'],
      'Archive & Record Keeping': ['Digital documentation archival'],
      'Regulatory Reporting': ['Closure reporting to regulators'],
      'Customer Feedback Collection': ['Post-closure satisfaction survey'],
      'Cross-sell / Re-engagement': ['New product offering communication']
    }
  },
  accounts: {
    'Journal Entry & Posting': {
      'Journal Entry Creation': ['Manual journal entries', 'System-generated entries'],
      'Entry Validation': ['Debit-credit verification', 'Account code check'],
      'Approval Workflow': ['Checker authorization', 'Senior accountant review'],
      'Ledger Posting': ['Post to general ledger'],
      'Reversal Entry': ['Journal reversal processing']
    },
    Reconciliation: {
      'Bank Reconciliation': ['Match bank statement with ledger', 'Identify unreconciled items'],
      'Loan Account Reconciliation': ['EMI payment matching', 'Outstanding balance verification'],
      'Inter-branch Reconciliation': ['Cross-branch transaction matching'],
      'Suspense Account Clearance': ['Resolve suspense entries'],
      'Month-end Reconciliation': ['Period-close balance matching']
    },
    'Ledger Management': {
      'Chart of Accounts Update': ['Add/modify GL accounts'],
      'Sub-ledger Maintenance': ['Customer loan sub-ledgers'],
      'Cost Center Allocation': ['Expense distribution'],
      'Intercompany Accounting': ['Group entity transactions'],
      'Ledger Review': ['Periodic ledger audit']
    },
    'Financial Reporting': {
      'Trial Balance Generation': ['Generate trial balance report'],
      'Balance Sheet Preparation': ['Asset-liability statement'],
      'Profit & Loss Statement': ['Income-expense summary'],
      'Cash Flow Statement': ['Liquidity position report'],
      'MIS Report Generation': ['Management information reports'],
      'Portfolio Report': ['Loan portfolio analysis']
    },
    'Tax & Compliance': {
      'TDS Calculation': ['Tax deducted at source computation'],
      'GST Filing': ['Goods and services tax return'],
      'Income Tax Provision': ['Advance tax computation'],
      'Regulatory Returns': ['Statutory filing compliance'],
      'Tax Audit Support': ['Document for tax audit']
    },
    'Audit & Controls': {
      'Internal Audit Review': ['Process control verification'],
      'Statutory Audit Support': ['External auditor documentation'],
      'Voucher Verification': ['Source document audit trail'],
      'Exception Report Review': ['Anomaly identification'],
      'Audit Finding Closure': ['Resolve audit observations']
    },
    'Period Close Activities': {
      'Accrual Posting': ['Month-end accrual entries'],
      'Prepaid Expense Amortization': ['Prepaid adjustment entries'],
      'Depreciation Posting': ['Asset depreciation entries'],
      'Provision Creation': ['NPA / loan loss provisions'],
      'Period Lock': ['Close accounting period']
    }
  }
}

export const APP_URL = {
  dev: 'https://devapi.myfinfi.com',
  uat: 'https://uatapi.myfinfi.com',
  prod: 'https://api.myfinfi.com'
}

// Notification trigger fields
const notificationFields = {
  customer_name: {
    label: 'Customer Name',
    value: 'customer_name',
    description: 'Name of the customer',
    eg: 'John Doe'
  },
  loan_amount: {
    label: 'Loan Amount',
    value: 'loan_amount',
    description: 'The disbursed loan amount',
    eg: '₹50,000'
  },
  disbursement_amount: {
    label: 'Disbursement Amount',
    value: 'disbursement_amount',
    description: 'Amount being disbursed',
    eg: '₹25,000'
  },
  disbursement_date: {
    label: 'Disbursement Date',
    value: 'disbursement_date',
    description: 'Date of disbursement',
    eg: '15/08/2024'
  },
  rejection_reason: {
    label: 'Rejection Reason',
    value: 'rejection_reason',
    description: 'Reason for disbursement rejection',
    eg: 'Insufficient documentation'
  },
  due_date: {
    label: 'Due Date',
    value: 'due_date',
    description: 'Payment due date',
    eg: '30/08/2024'
  },
  emi_amount: {
    label: 'EMI Amount',
    value: 'emi_amount',
    description: 'Monthly EMI amount',
    eg: '₹5,000'
  },
  outstanding_amount: {
    label: 'Outstanding Amount',
    value: 'outstanding_amount',
    description: 'Total outstanding balance',
    eg: '₹45,000'
  },
  payment_amount: {
    label: 'Payment Amount',
    value: 'payment_amount',
    description: 'Amount paid or received',
    eg: '₹5,000'
  },
  payment_date: {
    label: 'Payment Date',
    value: 'payment_date',
    description: 'Date of payment',
    eg: '28/08/2024'
  },
  days_overdue: {
    label: 'Days Overdue',
    value: 'days_overdue',
    description: 'Number of days payment is overdue',
    eg: '7 days'
  },
  late_fee_amount: {
    label: 'Late Fee Amount',
    value: 'late_fee_amount',
    description: 'Late fee applied amount',
    eg: '₹500'
  },
  grace_period_end: {
    label: 'Grace Period End Date',
    value: 'grace_period_end',
    description: 'Date when grace period expires',
    eg: '05/09/2024'
  },
  new_interest_rate: {
    label: 'New Interest Rate',
    value: 'new_interest_rate',
    description: 'Updated interest rate',
    eg: '12.5%'
  },
  old_interest_rate: {
    label: 'Old Interest Rate',
    value: 'old_interest_rate',
    description: 'Previous interest rate',
    eg: '11.5%'
  },
  ticket_id: {
    label: 'Ticket ID',
    value: 'ticket_id',
    description: 'Support ticket reference number',
    eg: 'TKT-2024-001'
  },
  meeting_date: {
    label: 'Meeting Date',
    value: 'meeting_date',
    description: 'Scheduled meeting date and time',
    eg: '02/09/2024 10:00 AM'
  },
  callback_date: {
    label: 'Callback Date',
    value: 'callback_date',
    description: 'Scheduled callback date and time',
    eg: '01/09/2024 2:00 PM'
  },
  account_number: {
    label: 'Account Number',
    value: 'account_number',
    description: 'Loan account number',
    eg: 'AC123456789'
  },
  reference_number: {
    label: 'Reference Number',
    value: 'reference_number',
    description: 'Transaction reference number',
    eg: 'REF-2024-08-001'
  }
}

// Notification triggers list with categorized structure
export const notificationTriggersOptions = {
  'Disbursement Events': {
    disbursmentInProgress: {
      title: 'Disbursement In Progress',
      params: [
        notificationFields.customer_name,
        notificationFields.disbursement_amount,
        notificationFields.account_number,
        notificationFields.reference_number
      ]
    },
    disbursmentCompleted: {
      title: 'Disbursement Completed',
      params: [
        notificationFields.customer_name,
        notificationFields.disbursement_amount,
        notificationFields.disbursement_date,
        notificationFields.account_number
      ]
    },
    disbursmentRejected: {
      title: 'Disbursement Rejected',
      params: [
        notificationFields.customer_name,
        notificationFields.disbursement_amount,
        notificationFields.rejection_reason,
        notificationFields.account_number
      ]
    }
  },
  'Payment Events': {
    paymentDueReminder: {
      title: 'Payment Due Reminder',
      params: [
        notificationFields.customer_name,
        notificationFields.emi_amount,
        notificationFields.due_date,
        notificationFields.outstanding_amount
      ]
    },
    paymentReceivedOrConfirmed: {
      title: 'Payment Received/Confirmed',
      params: [
        notificationFields.customer_name,
        notificationFields.payment_amount,
        notificationFields.payment_date,
        notificationFields.outstanding_amount
      ]
    },
    paymentFailedOrBounced: {
      title: 'Payment Failed/Bounced',
      params: [
        notificationFields.customer_name,
        notificationFields.emi_amount,
        notificationFields.due_date,
        notificationFields.reference_number
      ]
    },
    partialPaymentReceived: {
      title: 'Partial Payment Received',
      params: [
        notificationFields.customer_name,
        notificationFields.payment_amount,
        notificationFields.emi_amount,
        notificationFields.outstanding_amount
      ]
    },
    overpaymentReceived: {
      title: 'Overpayment Received',
      params: [
        notificationFields.customer_name,
        notificationFields.payment_amount,
        notificationFields.emi_amount,
        notificationFields.payment_date
      ]
    },
    autoDebitSetup: {
      title: 'Auto-Debit Setup',
      params: [
        notificationFields.customer_name,
        notificationFields.emi_amount,
        notificationFields.due_date,
        notificationFields.account_number
      ]
    },
    autoDebitCancelled: {
      title: 'Auto-Debit Cancelled',
      params: [
        notificationFields.customer_name,
        notificationFields.emi_amount,
        notificationFields.account_number
      ]
    }
  },
  'Overdue & Collections': {
    paymentOverdue: {
      title: 'Payment Overdue',
      params: [
        notificationFields.customer_name,
        notificationFields.emi_amount,
        notificationFields.days_overdue,
        notificationFields.outstanding_amount
      ]
    },
    lateFeeApplied: {
      title: 'Late Fee Applied',
      params: [
        notificationFields.customer_name,
        notificationFields.late_fee_amount,
        notificationFields.days_overdue,
        notificationFields.outstanding_amount
      ]
    },
    gracePeriodExpiring: {
      title: 'Grace Period Expiring',
      params: [
        notificationFields.customer_name,
        notificationFields.grace_period_end,
        notificationFields.emi_amount,
        notificationFields.outstanding_amount
      ]
    },
    legalNoticeIssued: {
      title: 'Legal Notice Issued',
      params: [
        notificationFields.customer_name,
        notificationFields.outstanding_amount,
        notificationFields.days_overdue,
        notificationFields.account_number
      ]
    },
    accountSentToCollection: {
      title: 'Account Sent to Collection',
      params: [
        notificationFields.customer_name,
        notificationFields.outstanding_amount,
        notificationFields.days_overdue,
        notificationFields.account_number
      ]
    }
  },
  'Account Management': {
    interestRateChange: {
      title: 'Interest Rate Change',
      params: [
        notificationFields.customer_name,
        notificationFields.old_interest_rate,
        notificationFields.new_interest_rate,
        notificationFields.account_number
      ]
    },
    loanRestructuredOrModified: {
      title: 'Loan Restructured/Modified',
      params: [
        notificationFields.customer_name,
        notificationFields.loan_amount,
        notificationFields.emi_amount,
        notificationFields.account_number
      ]
    },
    accountSuspended: {
      title: 'Account Suspended',
      params: [
        notificationFields.customer_name,
        notificationFields.account_number,
        notificationFields.outstanding_amount
      ]
    },
    accountReactivated: {
      title: 'Account Reactivated',
      params: [
        notificationFields.customer_name,
        notificationFields.account_number,
        notificationFields.outstanding_amount
      ]
    },
    loanClosedOrPaidOff: {
      title: 'Loan Closed/Paid Off',
      params: [
        notificationFields.customer_name,
        notificationFields.account_number,
        notificationFields.payment_date
      ]
    },
    earlySettlement: {
      title: 'Early Settlement',
      params: [
        notificationFields.customer_name,
        notificationFields.payment_amount,
        notificationFields.account_number,
        notificationFields.payment_date
      ]
    }
  },
  'Customer Service': {
    supportTicketCreatedOrResolved: {
      title: 'Support Ticket Created/Resolved',
      params: [
        notificationFields.customer_name,
        notificationFields.ticket_id,
        notificationFields.account_number
      ]
    },
    callbackScheduled: {
      title: 'Callback Scheduled',
      params: [
        notificationFields.customer_name,
        notificationFields.callback_date,
        notificationFields.account_number
      ]
    },
    meetingReminder: {
      title: 'Meeting Reminder',
      params: [
        notificationFields.customer_name,
        notificationFields.meeting_date,
        notificationFields.account_number
      ]
    },
    documentVerificationCompleted: {
      title: 'Document Verification Completed',
      params: [notificationFields.customer_name, notificationFields.account_number]
    }
  }
}

// Utility function to create notification trigger options for dropdowns
export const getNotificationTriggerOptions = () => {
  const groupedOptions = []

  Object.keys(notificationTriggersOptions).forEach((categoryName) => {
    // Add header
    groupedOptions.push({
      header: categoryName
    })

    // Add trigger options under this category
    // Add trigger options under this category
    const categoryTriggers = notificationTriggersOptions[categoryName]
    Object.keys(categoryTriggers).forEach((triggerKey) => {
      groupedOptions.push({
        text: categoryTriggers[triggerKey].title,
        value: triggerKey
      })
    })
  })

  return groupedOptions
}

export const DASHBOARD_WIDGET_CONFIG = {
  employeeStats: {
    title: 'Employee Statistics',
    settingsTitle: 'Employee Statistics (Overview of active employee statistics including)',
    description:
      'Total number of active employees, Number of employees clocked in today,Number of employees not clocked in today.'
  },
  progressStats: {
    title: 'Progress Statistics',
    settingsTitle: 'Progress Statistics (Summary of workflow progress across all activities)',
    description:
      'Number of pending items, Number of in-progress items, Number of completed items (Includes cases, visits, or tasks).'
  },
  caseAnalyticsStats: {
    title: 'Case Analytics',
    settingsTitle: 'Case Analytics (Visual representation of case distribution)',
    description:
      'Bar graph showing cases categorized by user-defined outcomes, Track case completion rates and trends.'
  },
  visitAnalyticsStats: {
    title: 'Visit Analytics',
    settingsTitle: 'Visit Analytics (Visual breakdown of visit statuses)',
    description:
      'Bar graph displaying visits by status: PENDING, IN-PROGRESS, or COMPLETED, Monitor visit workflow efficiency.'
  },
  visitCollectionStats: {
    title: 'Top Collected Visits',
    settingsTitle: 'Top Collected Visits (Highest-performing visits overview)',
    description:
      'Card view displaying the top five most frequently collected visits,Quick reference for popular visit types.'
  },
  teleCallingStats: {
    title: 'Tele Calling Activity',
    settingsTitle: 'Tele Calling Activity (Calls: total, Received by agent, Received by customer)',
    description:
      'Bar chart showing call volumes by category: Total, Received by Agent, and Received by Customer.'
  },
  loanStats: {
    title: 'Loan Statistics',
    settingsTitle: 'Loan Statistics (Comprehensive loan portfolio overview)',
    description:
      'Total number of active loans, Total loan amount outstanding, Loan status distribution (Approved, Disbursed, Closed, etc.).'
  },
  emiStats: {
    title: 'EMI Statistics',
    settingsTitle: 'EMI Statistics (Summary of Equated Monthly Installment (EMI) activity)',
    description:
      'Number of pending EMI payments,Number of overdue EMI payments,Number of completed EMI payments.'
  },
  recentEmis: {
    title: 'Recent EMI Transactions',
    settingsTitle: 'Recent EMI Transactions (Latest EMI payment history)',
    description:
      'List of most recent EMI transactions,Payment status for each transaction,Detailed transaction information.'
  },
  emiActions: {
    title: 'EMI Management Actions',
    settingsTitle: 'EMI Management Actions (Quick actions for EMI operations)',
    description:
      'Process EMI payments,Send payment reminders,Manage EMI schedules,Handle payment defaults.'
  }
}

// Utility function to get all triggers as a flat array for existing components
export const getAllNotificationTriggers = () => {
  const allTriggers = []

  Object.keys(notificationTriggersOptions).forEach((categoryName) => {
    const categoryTriggers = notificationTriggersOptions[categoryName]
    Object.keys(categoryTriggers).forEach((triggerKey) => {
      allTriggers.push({
        label: categoryTriggers[triggerKey].title,
        value: triggerKey
      })
    })
  })

  return allTriggers
}

// Search configuration utilities
export const SearchConfig = {
  // Get route configuration for a given path
  getRouteConfig(path) {
    return Object.values(routeConfig).find((route) => path.startsWith(route.path)) || {}
  },

  // Get available selection types for a route and active tab
  getSelectItems(routeConfig, activeTab) {
    if (!routeConfig) return []

    let selectValues = routeConfig.selectValues || [
      SelectionTypes.EMPLOYEES,
      SelectionTypes.TEAMS,
      SelectionTypes.CUSTOMERS,
      SelectionTypes.PARTNERS,
      SelectionTypes.WORKFLOW_TEMPLATES
    ]

    if (routeConfig.activeTabFilter) {
      const filterMap = routeConfig.activeTabFilter
      selectValues = filterMap[activeTab] || filterMap.Default || selectValues
    }

    return selectValues.map((value) => ({
      text: value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(),
      value
    }))
  },

  // Get query parameter key for selection type and tab
  getQueryKey(routeConfig, selectionType, activeTab) {
    if (!routeConfig.queryKeys || !routeConfig.queryKeys[selectionType]) return null

    const queryKeys = routeConfig.queryKeys[selectionType]
    return queryKeys[activeTab] || queryKeys.default || null
  },

  // Format display name for users
  formatUserName(user) {
    return user.fullName || `${user.firstName || ''} ${user.lastName || ''}`.trim()
  },

  // Format display name for customers
  formatCustomerName(customer) {
    return (
      customer.customerFullName ||
      `${customer.firstName || ''} ${customer.lastName || ''}`.trim() ||
      'Unknown'
    )
  },

  // Check if current route/tab uses customer search format
  isCustomerSearchFormat(routeConfig, selectionType, activeTab, path) {
    return (
      selectionType === SelectionTypes.CUSTOMERS &&
      (path.startsWith(routeConfig.customers?.path || '/workforce/customers') ||
        path.startsWith('/workforce/loan_management') ||
        path.startsWith('/workforce/collection_management') ||
        path.startsWith('/workforce/base') ||
        activeTab === 'CaseCustomer')
    )
  },

  // Get unique identifier for search items based on selection type
  getUniqueId(item, selectionType) {
    switch (selectionType) {
      case SelectionTypes.TEAMS:
        return item.value?.cNo
      case SelectionTypes.CUSTOMERS:
        return item.value?.customerId
      case SelectionTypes.PARTNERS:
        return item.value?.partnerId
      case SelectionTypes.WORKFLOW_TEMPLATES:
        return item.value?.templateId
      default: // EMPLOYEES
        return item.value?.empId
    }
  }
}

export const dynamicRequestPath = {
  collection_management: {
    path: 'collection-management-field-mapping',
    key: 'collectionManagementFieldMapping'
  },
  loan_management: {
    path: 'loan-management-field-mapping',
    key: 'loanManagementFieldMapping'
  }
}

export const employeeTypes = ['CONTRACT', 'FULL_TIME', 'OTHERS', 'PART_TIME', 'TEMPORARY']

export const UpdateCaseDialogLabels = {
  FE_NAME: 'FEName',
  STATUS: 'status',
  ASSIGN_LOCATION: 'AssignLocation',
  ASSIGN_DEPARTMENT: 'AssignDepartment',
  SALARY_TEMPLATE: 'SalaryTemplate',
  TEAMS: 'Teams',
  BRANCHES: 'Branches'
}
